export var ORGANIZATION_TARGET = {
    direct: 'direct',
    partner: 'partner'
};
export var PlanFilterQueryParams = /*#__PURE__*/ function (PlanFilterQueryParams) {
    PlanFilterQueryParams["ByPlanType"] = "filters[plans.group][$in]";
    PlanFilterQueryParams["ByLicenseType"] = "filters[plan_item_types.identifier][$in]";
    PlanFilterQueryParams["ByBillingCycle"] = "filters[plans.duration_interval]";
    PlanFilterQueryParams["ByBillingCycleUnit"] = "filters[plans.duration_unit]";
    PlanFilterQueryParams["ByPlanMode"] = "plans.target";
    PlanFilterQueryParams["ByPackageMode"] = "packages.target";
    PlanFilterQueryParams["ByArchivedStatus"] = "filters[packages.is_archived]";
    /**
     * The plans list joins `products` on `plans.product_id` and allowlists the joined column, so the
     * list filters on `products.identifier` rather than on anything under `plans.`.
     */
    PlanFilterQueryParams["ByProduct"] = "filters[products.identifier]";
    return PlanFilterQueryParams;
}({});
/**
 * Sort keys accepted by `GET /v1/plans/list`. `createdAt` has no column of its own — it is the
 * default order only, which is why the table passes no default sort descriptor.
 */
export var PLANS_SORT_KEYS = {
    title: 'plans.title',
    createdAt: 'plans.created_at'
};
